import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
const NoticeBoardCreate = ({ props, classes }) => {
    const navigate = useNavigate();
    const params = useParams();
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastMessageType, setToastMessageType] = useState('');
  const [redirectURL, setRedirectURL] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [notice, setNotice] = useState('')
  const [noticeNameState, setNoticeNameState]= useState(false)
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
    if (redirectURL !== "") {
      setRedirectURL("");
      navigate(redirectURL);
    }
  };
  const isValidated = () => {
    if (notice === "") {
        setNoticeNameState(true);
    } else {
        setNoticeNameState(false);
    }
   
    if (notice) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if(params.noticeBoardId){
    GetData();
    }
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.NOTICE_BOARD_GET_BY_ID + params.noticeBoardId,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setNotice(result?.data?.name)
    }
  };

  const updateRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.NOTICE_BOARD_UPDATE + params?.noticeBoardId,
      method: "PUT",
      authToken: authToken,
      data: {
        name: notice,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
  const saveRoleInformation = async () => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.NOTICE_BOARD_CREATE,
      method: "POST",
      authToken: authToken,
      data: {
        name: notice,
      },
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      return "SUCCESS";
    }
  };
const handleroleSubmit = async (event) => {
  if (isValidated()) {
    toastUpdate("", "", false);
    let status = "";
    if (params.noticeBoardId) {
      status = await updateRoleInformation();
    } else {
      status = await saveRoleInformation();
    }
    if (status === "SUCCESS") {
      const msg = params.noticeBoardId
        ? "Notice updated successfully!"
        : "Notice created successfully!";
        toastUpdate("Success", msg, true);
      setRedirectURL(`/coreservice/NoticeBoard`);
    }
  }
};
  const handlecancelrole = () => {
    navigate("/coreservice/NoticeBoard");
  };
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={params.ornamentId ? "Edit Notice" : "Create Notice"}
          button1=" Save"
          button2=" Cancel"
          button1click={handleroleSubmit}
          button2click={handlecancelrole}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
         <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomeTextField
              label="Notice"
              required
              error={noticeNameState}
              id="lp_min_role"
              value={notice || ""}
              setState={setNotice}
              setError={setNoticeNameState}
            />
          </Grid>
       
        </Grid>
      </Grid>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}

      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

export default NoticeBoardCreate;
